import React, { useEffect, useState, useRef } from "react";
import Header from "../components/header";
import Footer from "../components/footer";
import CaptchaComponent from "../components/CaptchaComponent";
import { Link, Navigate, useNavigate } from "react-router-dom";
import OTPInput from "react-otp-input";
import Modal2 from "../components/model2";
import {sendWelcomeEmailBuyer} from "../../utility/emailUtility";


const BuyerSignup = () => {

    const navigate = useNavigate();
    const [username, setFullName] = useState("");    
    const fullNameInputRef = useRef(null);
    const selectISDRef = useRef(null);
    const mobileRef = useRef(null);
    const emailRef = useRef(null);
    const captchaRef = useRef(null); // Add this ref for the captcha input
    
    const [isChecked, setIsChecked] = useState(false);

    const [isVisibleOTP, setIsVisibleOTP] = useState(false);
    const [isVisibleRegister, setIsVisibleRegister] = useState(true);
    const [otp, setOtp] = useState(""); // Added state for OTP

    const [isdcodes, setISDCode] = useState([]);
    const [selectedISDCode, setSelectedISDCode] = useState('99');
    const [isdSearchTerm, setISDSearchTerm] = useState('');

    const [mobile, setMobileNumber] = useState("");
    const [isValidMobile, setIsValidMobile] = useState(true);
    const [isDuplicateMobile, setIsDuplicateMobile] = useState(false); // New state for duplicate mobile

    const [email, setEmail] = useState("");
    const [isValidEmail, setIsValidEmail] = useState(true);
    const [isDuplicateEmail, setIsDuplicateEmail] = useState(false); // New state for duplicate email
    const [captchaValue, setCaptchaValue] = useState('');
    const [enteredCaptcha, setEnteredCaptcha] = useState('');

    

   

    const fetchData = async (url, setData) => {
        try {
            const response = await fetch(url);
            const data = await response.json();
            setData(data);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    useEffect(() => {
        fullNameInputRef.current.focus();
        fetchData('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-ISDCodeList', setISDCode);
    }, []);

    const handleCheck = (event) => {
        setIsChecked(event.target.checked);
    };

    const handleFullNameChange = (event) => {
        setFullName(event.target.value);
    };

    const handleISDCodeChange = (event) => {
        setSelectedISDCode(event.target.value);
        setMobileNumber("");
    };

    const handleMobileNumberChange = async (event) => {
        const inputMobileNumber = event.target.value;
        const maxLength = selectedISDCode === '99' ? 10 : 11;

        if (/^\d*$/.test(inputMobileNumber) && inputMobileNumber.length <= maxLength) {
            setMobileNumber(inputMobileNumber);
            setIsValidMobile(true);

            // Check for duplicate mobile number
            await checkForDuplicates(inputMobileNumber, email);

        } else {
            setIsValidMobile(false);
        }
    };

    const handleEmailChange = async (event) => {
        const inputEmail = event.target.value;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        setEmail(inputEmail);
        setIsValidEmail(emailRegex.test(inputEmail) || inputEmail === "");

        // Check for duplicate email
        await checkForDuplicates(mobile, inputEmail);
    };

    const handleCaptchaChange = (generatedCaptcha, userInput) => {
        setCaptchaValue(generatedCaptcha); // Set the generated CAPTCHA
        setEnteredCaptcha(userInput); // Set the entered CAPTCHA
    };

    const handleKeyPress = (event) => {
        const value = isdSearchTerm + event.key;
        setISDSearchTerm(value);

        const exactMatch = isdcodes.find(code => code.isdCode === value);
        const partialMatch = isdcodes.find(code => code.isdCode.startsWith(value) || code.isdCodeName.toLowerCase().includes(value.toLowerCase()));

        const match = exactMatch || partialMatch;

        if (match) {
            handleISDCodeChange({ target: { value: match.isdCode } });
        }
    };

    const checkForDuplicates = async (mobile, email) => {

        if (!mobile && !email) return; // Ensure values are present before checking

        try {
            const response = await fetch('https://igapi.heuristticminds.com/api/UsersList/Check-CheckDuplicateMobileEmail', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ mobile, email }),
            });

            if (response.ok) {
                const result = await response.json();
                setIsDuplicateMobile(result.isDuplicateMobile);
                setIsDuplicateEmail(result.isDuplicateEmail);
            } else {
                console.error('Error checking for duplicates:', response.statusText);
            }
        } catch (error) {
            console.error('Error checking for duplicates:', error);
        }
    };

    const handleRegister = async (event) => {
        event.preventDefault();

        // Validate all fields
        if (username.trim() === '') {
            alert('Please enter your full name.');
            fullNameInputRef.current.focus();
            return;
        }
        if (mobile.trim() === '') {
            alert('Please enter mobile number');
            mobileRef.current.focus();
            return;
        }
        const minLength = selectedISDCode === '99' ? 10 : 8; // Minimum length depends on ISD code
        if (mobile.length !== minLength) {
            alert('Please enter a valid mobile number with the correct number of digits.');
            mobileRef.current.focus();
            return;
        }
        if (!isValidMobile) {
            alert('Please enter a valid mobile number.');
            mobileRef.current.focus();
            return;
        }
        if (isDuplicateMobile) {
            alert("Duplicate mobile number. Please use a different one.");
            return;
        }
        if (email.trim() === '') {
            alert("Please enter a valid email address.");
            emailRef.current.focus();
            return;
        }
        if (isDuplicateEmail) {
            alert("Duplicate email found. Please use a different one.");
            return;
        }
        if (!isValidEmail) {
            alert('Please enter a valid email address.');
            emailRef.current.focus();
            return;
        }
        
        // Focus on the captcha input after confirming password
        if (enteredCaptcha.trim() === '') {
            alert("Please enter the captcha.");
            if (captchaRef.current) { // Ensure captchaRef is not null before focusing
                captchaRef.current.focus();
            }
            return;
        }
        if (enteredCaptcha !== captchaValue) {
            alert("Invalid captcha");
            if (captchaRef.current) {
                captchaRef.current.value = ''; // Clear the input field if captcha is invalid
                captchaRef.current.focus();
            }
            return;
        }
        if(!isChecked)
            {
                alert('Please read and accept Terms & Conditions..');
                return;
            }
        const formData = {
            username,
            userType_id: 3,  // for Buyer 
            ISDCode: selectedISDCode,
            mobile,
            email,
            password:'',
        };
        try {
            const response = await fetch('https://igapi.heuristticminds.com/api/UsersList/Add-SaveUserDetails', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            if (response.ok) {
                console.log('Form data saved successfully');

                // Send email after user is successfully saved

                // Proceed to send email
                await sendWelcomeEmailBuyer(username, selectedISDCode, mobile, email);

                alert("Registered Successfully !! Please Check confirmation on your registered Email ID : "+email+  " !!");
                setFullName("");
                setMobileNumber("");
                setEmail("");
                setIsValidMobile(true);
                setIsValidEmail(true);
                fullNameInputRef.current.focus();
                navigate(`/`);
                
            } else {
                console.error('Error saving form data:', response.statusText);
            }
        } catch (error) {
            console.error('Error saving form data:', error);
        }
    };



    return (
        <>
            <Header />
            <div className="bg-light p-4" style={{ marginTop: '110px' }}>
                <div className="col-lg-5 col-md-6 col-sm-8 m-auto bg-white border">
                    <div className="box500">
                        {/* register div */}
                        <div id="" className={`${isVisibleRegister ? 'show' : 'hide'}`}>
                            <h5 className="">Register an Account (As Buyer)</h5>
                            <hr className="mb-4" />
                            <div className="row_input">
                                <span className="lbl1">Full Name</span>
                                <input
                                    type="text"
                                    value={username}
                                    id="fullName"
                                    maxLength={35}
                                    onChange={handleFullNameChange}
                                    ref={fullNameInputRef}
                                    tabIndex={1}
                                    placeholder="Enter your full name"
                                    className="txt1"
                                    autoComplete="off"
                                />
                            </div>
                            <div className="d-flex">
                                <div className="row_input me-3" style={{ width: 150 }}>
                                    <span className="lbl1">ISD Code</span>

                                    <select
                                        id="selectedISDCode"
                                        ref={selectISDRef}
                                        value={selectedISDCode}
                                        name="selectedISDCode"
                                        className="txt1"
                                        onChange={handleISDCodeChange}
                                        tabIndex={3}
                                        onKeyDown={handleKeyPress}
                                    >
                                        <option value="0">--ISD--</option>
                                                {isdcodes.map((code) => (
                                                    <option key={code.isdCode} value={code.isdCode}>
                                                        {code.isdCodeName}
                                                    </option>
                                                ))}

                                    </select>
                                </div>
                                <div className="row_input">
                                    <span className="lbl1">Mobile Number</span>
                                    <input
                                        type="text"
                                        value={mobile}
                                        onInput={handleMobileNumberChange}
                                        id="mobileNumber"
                                        tabIndex={4}
                                        ref={mobileRef}
                                        placeholder="Enter mobile number"
                                        className={`txt1 ${isValidMobile ? "" : "is-invalid"}`}
                                        autoComplete="off"
                                    />
                                </div>
                                {!isValidMobile && (
                                            <div className="invalid-feedback">Mobile number exceeds maximum length.</div>
                                        )}
                            </div>
                            <div className="row_input">
                                <span className="lbl1">Email Address</span>
                                <input
                                    type="text"
                                    value={email}
                                    onInput={handleEmailChange}
                                    id="email"
                                    tabIndex={5}
                                    maxLength={45}
                                    ref={emailRef}
                                    placeholder="Enter your email address"
                                    className={`txt1 ${isValidEmail ? "" : "is-invalid"}`}
                                    autoComplete="off"
                                />
                            </div>

                            <div className="row_input">
                                <CaptchaComponent
                                    value={enteredCaptcha}
                                    ref={captchaRef}
                                    onCaptchaChange={handleCaptchaChange}
                                    tabIndex={8}
                                />
                            </div>
                            <div className="row_input">
                                <label className="d-flex align-items-center" style={{ fontSize: '14px' }}>
                                    <input
                                        type="checkbox"
                                        checked={isChecked}
                                        onChange={handleCheck}
                                    />&nbsp;
                                    I accept &nbsp;<Link to="/termsConditions" target="_blank">Terms and Conditions</Link>
                                </label>
                            </div>
                            <div className="pb-2 text-center">
                                <button
                                    type="submit"
                                    className="btn btn-dark w-50 font-weight-bold mt-2 p-2 rounded-1"
                                    onClick={handleRegister}
                                >Register</button>
                            </div>
                            <div className="pb-2 text-center">Already Registered, <Link to={'/buyerLogin'} tabIndex={10}>Login</Link></div>
                        </div>

                        {/* OTP div */}
                        <div id="otp" className={`${isVisibleOTP ? 'show' : 'hide'}`}>
                            <div className="otp_icon" >
                                <img src="../../images/icon-otp-verification.svg" />
                            </div>
                            <div className="text-center">
                                <h5>Verify with OTP (Check your phone)</h5>
                                <small className="text-black">We've Sent a code to 97178539XX</small>
                                <div className="p-4">
                                    <OTPInput
                                        value={otp}
                                        onChange={setOtp}
                                        containerStyle="otp_style"
                                        numInputs={4}
                                        renderSeparator={<span>-</span>}
                                        renderInput={(props) => <input {...props} />}
                                    />
                                    <small className="d-block mt-3">Didn't get the code? <span className="link_btn">Click to resend</span></small>
                                </div>

                                <button
                                    type="submit"
                                    className="btn btn-dark w-50 font-weight-bold mt-2 p-2 rounded-1"
                                >Submit</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
      
            <Footer />
        </>
    );
};

export default BuyerSignup;
